export const keywordQueryKeys = {
  all: ["keyword"] as const,
  list: () => [...keywordQueryKeys.all, "list"] as const,
  withCategory: () => [...keywordQueryKeys.all, "withCategory"] as const,
};
